import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { getApprovalDiff } from '../api';
import type { ApprovalRequest } from '../types';
import { APPROVALS_KEY } from './useApprovals';

export const useApprovalDiff = (
  request: ApprovalRequest | undefined,
  baseVersionId?: string,
  enabled = true
) => {
  const scope = useSelector(
    (state: any) => `${state.auth.current_company}:${state.auth.current_employee}`
  );
  return useQuery({
    queryKey: [
      APPROVALS_KEY,
      'diff',
      scope,
      request?.id,
      request?.version_id,
      baseVersionId ?? 'default',
    ],
    queryFn: () => getApprovalDiff(request as ApprovalRequest, baseVersionId),
    enabled: enabled && !!request,
    refetchOnWindowFocus: false,
  });
};
